<template>
  <v-col class="pa-0">
    <v-row no-gutters>
      <v-col cols="11" class="pa-0" v-if="fields.length > 0">
        <v-row no-gutters v-for="(field, idx) of fields" :key="idx">
          <v-col cols="10" class="kw-field">
            <v-row no-gutters align="center">
              <v-col cols="3" class="pa-0">
                <v-text-field
                  :readonly="!canEdit"
                  :disabled="isCopied"
                  :rules="notEmpty"
                  v-model="field.court"
                  outlined
                  type="text"
                  @change="updateKwField"
                />
              </v-col>
              <v-col cols="auto" class="pb-7">
                {{ '/' }}
              </v-col>
              <v-col cols="4" class="pa-0">
                <v-text-field
                  :readonly="!canEdit"
                  :disabled="isCopied"
                  :rules="notEmpty"
                  v-model="field.number"
                  outlined
                  type="text"
                  @change="updateKwField"
                />
              </v-col>
              <v-col cols="auto" class="pb-7">
                {{ '/' }}
              </v-col>
              <v-col cols="3" class="pa-0">
                <v-text-field
                  :readonly="!canEdit"
                  :disabled="isCopied"
                  :rules="notEmpty"
                  v-model="field.digit"
                  outlined
                  type="text"
                  @change="updateKwField"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" class="pa-2">
            <v-btn
              fab
              dark
              small
              color="danger"
              class="mr-1"
              v-if="canEdit && !isCopied && (canBeEmpty || attribute.value.length > 1)"
              @click="deleteKwField(idx)"
            >
              <v-icon dark>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pa-0" v-else>
        <v-subheader class="pa-0" style="height: auto; min-height: 48px">
          {{ 'Dodaj numer księgi wieczystej' }}
        </v-subheader>
      </v-col>
      <v-col cols="1">
        <v-col cols="auto" class="pa-2">
          <v-btn fab dark small color="primary" class="mr-1" v-if="canEdit && !isCopied" @click="addKwField">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    attribute: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isCopied: {
      type: Boolean,
      required: false,
      default: false
    },
    isOffer: {
      type: Boolean,
      default: false
    },
    canBeEmpty: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    fields: []
  }),
  computed: {
    notEmpty() {
      return [];
      // return [field => !!field || ''];
    }
  },
  methods: {
    addKwField() {
      this.fields.push({ court: '', number: '', digit: '' });
      this.updateKwField();
    },
    deleteKwField(idx) {
      this.fields.splice(idx, 1);
      this.updateKwField();
    },
    updateKwField() {
      const fields = [];
      for (const field of this.fields) {
        const value = `${field.court}/${field.number}/${field.digit}`;
        fields.push(value);
      }
      this.attribute.value = fields;
    }
  },
  mounted() {
    if (this.attribute.value) {
      for (const attribute of this.attribute.value) {
        const split = attribute.split('/');
        this.fields.push({ court: split[0], number: split[1], digit: split[2] });
      }
    }
  }
};
</script>
<style>
.kw-field {
  display: inherit;
  font-size: 34px;
  padding: 0;
}
</style>
